'use client'

import { Col } from '@repo/ui/components'
import { InviteCards } from './invite-cards'
import { InviteTable } from './invite-table'
import { ReferralProgram } from './referral-program'
import { ReferralProgramAgent } from './referral-program-agent'

export const InviteContainer = ({
  showAgentReferral = true,
}: {
  showAgentReferral?: boolean
}) => {
  return (
    <Col className='gap-2xl mb-20 md:mb-0'>
      <InviteCards />
      <div className='flex flex-col md:flex-row gap-md'>
        <ReferralProgram />
        {showAgentReferral && <ReferralProgramAgent />}
      </div>
      <InviteTable />
    </Col>
  )
}
